module.exports = function() {
    var os;

    this.browser = this.browser || {};
    this.browser.OS = {
        MACOSX : "Mac OS X",
        WINDOWS : "Windows",
        ANDROID : "Android",
        IOS : "iOS",
        OTHER : "Other"
    };

    this.browser.getOS = function() {
        if (!os) {
            if (/Android/i.test(navigator.userAgent)) {
                os = this.OS.ANDROID;
            } else if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
                os = this.OS.IOS;
            } else if (/Macintosh|Mac OS X/i.test(navigator.userAgent)) {
                os = this.OS.MACOSX;
            } else if (/Windows/i.test(navigator.userAgent)) {
                os = this.OS.WINDOWS;
            } else {
                os = this.OS.OTHER;
            }
        }

        return os;
    };

    return $.Deferred().resolve().promise();
};